import React, { Component } from 'react';

import SecFilingView from 'client/components/sec-filing';
import SecFilings from 'client/components/sec-filings';
import Seo from 'client/components/seo';

import { BundleData } from 'client/bundles/types';

interface Props {
    data: BundleData;
}

export default class SecPage extends Component<Props> {
    render() {
        const { sec, baseUrl } = this.props.data;
        const sectionTitle = 'SEC Filings';
        const title = sec.singleFiling ? sec.singleFiling.title : sectionTitle;
        const props = {
            currentYear: sec.currentYear,
            groupId: sec.groupId,
            years: sec.years,
            types: sec.types,
            singleFiling: sec.singleFiling,
            baseUrl,
            title
        };

        return (
            <>
                <Seo title={title} />

                {sec.singleFiling ?
                    <SecFilingView {...props} singleFiling={sec.singleFiling} sectionTitle={sectionTitle} /> :
                    <SecFilings {...props} yearFilings={sec.yearFilings} />
                }
            </>
        );
    }
}
